

















import { Vue, Component, Prop } from 'vue-property-decorator';
import { Swipe, SwipeItem } from 'vant';
Vue.use(Swipe).use(SwipeItem);
@Component
export default class SwiperTop extends Vue {}
